module.exports = __webpack_public_path__ + "static/media/lt.70975be0.svg";